import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as cdesde } from "assets/finicio_ico.svg";
import { ReactComponent as chasta } from "assets/ffin_ico.svg";
import { Controller } from "react-hook-form";
import { Box, Grid, SvgIcon, TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    borderRadius: 50,
    backgroundColor: theme.palette.input.main,
    height: "3rem",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    textAlign: "center",
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },

  date2: {
    marginTop: -2,
    zIndex: -10,
  },
  date1: {
    zIndex: -10,
  },
  reactpopper: {
    zIndex: 99999,
  },
}));
const InputPeriodo = ({ control, name, val, errors, label, getfunct }) => {
  const classes = useStyles();
  const f1 = useRef();
  const f2 = useRef();
  
    const format = (date) => {
      const options = { day:'numeric', month:'long', year:'numeric' };
      const formattedDate = new Date(date+'T12:00:00').toLocaleDateString("es-MX", options);
      const [day,d1 , month, d2,year] = formattedDate.split(" ");
      return `${day} ${month} ${year}`;
    };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={val}
      rules={{
        required: {
          value: true,
          message: "Campo requerido",
        },
      }} // ,
      render={({ value, onChange }) => (
        <>
          <Paper component="form" className={classes.root}>
            <IconButton title="Fecha inicio" onClick={() => f1.current.showPicker()}>
              <SvgIcon component={cdesde} viewBox="0 0 32 32" />
            </IconButton>
            <InputBase
              className={classes.input}
              placeholder="Inicio"
              value={format(value.finicio) || ""}
              inputProps={{ "aria-label": "Inicio" }}
            />
            <IconButton title="Fecha fin" onClick={() => f2.current.showPicker()}>
              <SvgIcon component={chasta} viewBox="0 0 32 32" />
            </IconButton>
            <InputBase
              className={classes.input}
              value={format(value.ffin) || ""}
              placeholder="Final"
              inputProps={{ "aria-label": "Inicio" }}
            />
          </Paper>
          <Box sx={{ marginTop: -28 }}>
            <Grid item container>
              <Grid item xs={6}>
                <TextField
                  className={classes.date1}
                  fullWidth
                  type="date"
                  size="small"
                  defaultValue={value.finicio}
                  name="desde"
                  onChange={(e) => onChange({ ...value, finicio: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  inputRef={f1}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  className={classes.date1}
                  fullWidth
                  type="date"
                  size="small"
                  defaultValue={value.ffin}
                  name="hasta"
                  onChange={(e) => onChange({ ...value, ffin: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  inputRef={f2}
                />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    />
  );
};
//field.onChange({ ...field, fechaf: e.target.value })
export default InputPeriodo;
